import React, { useEffect, useState } from "react";
import NextImage from "../common/NextImage";
import { loadStyles } from "../../utils/cssLoader";
import { getImageUrl } from "../../utils/generalLiveCenter";

const BasketballInfoTable = ({
  ServerData,
  dictionary = {},
  loadCSS = true,
  dataClient = false,
  title,
  sport = "basketball",
}) => {
  const [clientData, setClientData] = useState(null);
  const rawData = dataClient ? clientData : ServerData;
  // Handle both { data: {...} } and direct data structure
  const data = rawData?.data || rawData;
  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS) {
      loadStyles("basketballinfo");
    }
  }, [loadCSS]);

  return (
    <>
      {title ? <h1>{title}</h1> : null}
      <div className="basketball_info_container">
        <div className="basket_tv">
          <div className="global_table striped player_lineup">
            <table>
              <thead>
                <tr>
                  <th>Rounds</th>
                  <th>Q1</th>
                  <th>Q2</th>
                  <th>Q3</th>
                  <th>Q4</th>
                  {data?.ot && <th>OT</th>}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="players_inf">
                      <div className="avtar">
                        <NextImage
                          src={getImageUrl('', '', sport, data?.competitors?.htid)}
                          width={26}
                          height={26}
                          alt="home team"
                        />
                      </div>
                      <div className="avtar_inf">
                        <strong className="name">{data?.competitors?.htn}</strong>
                      </div>
                    </div>
                  </td>
                  <td>{data?.q1 !== "" ? data?.q1?.split("-")?.[0] : "-"}</td>
                  <td>{data?.q2 !== "" ? data?.q2?.split("-")?.[0] : "-"}</td>
                  <td>{data?.q3 !== "" ? data?.q3?.split("-")?.[0] : "-"}</td>
                  <td>{data?.q4 !== "" ? data?.q4?.split("-")?.[0] : "-"}</td>
                  {data?.ot && <td>{data?.ot?.split("-")?.[0] || "-"}</td>}
                </tr>
                <tr>
                  <td>
                    <div className="players_inf">
                      <div className="avtar">
                        <NextImage
                          src={getImageUrl('', '', sport, data?.competitors?.atid)}
                          width={26}
                          height={26}
                          alt="away team"
                        />
                      </div>
                      <div className="avtar_inf">
                        <strong className="name">{data?.competitors?.atn}</strong>
                      </div>
                    </div>
                  </td>
                  <td>{data?.q1 !== "" ? data?.q1?.split("-")?.[1] : "-"}</td>
                  <td>{data?.q2 !== "" ? data?.q2?.split("-")?.[1] : "-"}</td>
                  <td>{data?.q3 !== "" ? data?.q3?.split("-")?.[1] : "-"}</td>
                  <td>{data?.q4 !== "" ? data?.q4?.split("-")?.[1] : "-"}</td>
                  {data?.ot && <td>{data?.ot?.split("-")?.[1] || "-"}</td>}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="basket_tv">
          <div className="leg_head">
            <h2>Venue</h2>
          </div>

          <div className="global_table striped basket_venue_table">
            <table>
              <tbody>
                <tr>
                  <td>Stadium:</td>
                  <td>{data?.venue?.name || "-"}</td>
                </tr>
                <tr>
                  <td>Capacity:</td>
                  <td>{data?.venue?.capacity || "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasketballInfoTable;
